import { i18next } from '@vmos2/core';

import { isPhone } from './isPhone';

export const validatePhoneForm = (code: string, value: string, field: string) => {
  const errors: Record<string, string> = {};

  try {
    if (isPhone(code, value)) {
      errors[field] = i18next.t('validations:invalidMobilePhone');
    }
  } catch (e) {
    errors[field] = i18next.t('validations:invalidMobilePhone');
  }

  return errors;
};
